import httpClient from '@/http-client'

export const get = (Options = {}) => {
  return httpClient
    .get('/api/schedule-times', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/schedule-times', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const find = (id, Options = {}) => {
  return httpClient
    .get(`/api/schedule-times/${id}`, Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const update = data => {
  return httpClient
    .put(`/api/schedule-times/${data.sc_time_id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const destroy = id => {
  return httpClient
    .delete(`/api/schedule-times/${id}`)
    .then(response => Promise.resolve(response.data))
}

export const getSubProgram = (Options = {}) => {
  return httpClient
    .get('/api/schedule-times/sub-programs', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTimeId = (Options = {}) => {
  return httpClient
    .get('/api/schedule-times/schedule-time-id', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const getTimeSwap = (Options = {}) => {
  return httpClient
    .get('/api/schedule-times/time-swapes', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export default {
  get,
  find,
  store,
  update,
  destroy,
  getSubProgram,
  getTimeId,
  getTimeSwap
}
